import React, { useEffect, useState } from "react";
import { API_ASSET, API_ASSET_USER } from "../../config/Endpoints";
import { getApi } from "../../utils/api";
import Cookies from "js-cookie";
import Pagination from "../../components/Pagination";
import SortableTable from "../../components/SortableTable";
import { ThreeDots } from "react-loader-spinner";

const EmployeeAsset = ({ assestData, employeeId }) => {
  const [assetList, setAssetList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalAssest, setTotalAssest] = useState(0);
  const accessToken = Cookies.get("accessToken");

  const columns = [
    { key: "manufacture", label: "Manufacture" },
    {
      key: "assetName",
      label: "Asset Name",
      render: (row) => row.assestName,
    },
    { key: "serialNumber", label: "Serial Number" },
    { key: "owner", label: "Owner" },
  ];

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleLimitChange = (e) => {
    setLimit(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    fetchList();
  }, [currentPage, limit]);

  const fetchList = () => {
    setIsLoading(true);
    setAssetList([]);
    const url = employeeId
      ? API_ASSET +
        `?pageSize=${limit}&page=${currentPage}&employeeId=${employeeId}`
      : API_ASSET_USER + `?pageSize=${limit}&page=${currentPage}`;

    getApi(url, accessToken)
      .then((res) => {
        if (res.status === 200) {
          setAssetList(res.data.data);
          setTotalAssest(res.data.totalAssest);
          setTotalPages(res.data.totalPages);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="d-grid gap-2 d-md-flex justify-content-md-end">
        {isLoading && (
          <div className="text-center my-3">
            <ThreeDots
              height="25"
              width="80"
              radius="9"
              color="white"
              ariaLabel="three-dots-loading"
              visible={true}
            />
          </div>
        )}
        <button
          className="btn theme-background-color add-dependent text-right mb-2"
          onClick={fetchList}
          disabled={isLoading}
        >
          Refresh
        </button>
      </div>

      {!isLoading && assetList?.length === 0 && (
        <div className="fs-4 text-secondary text-center">
          No records available
        </div>
      )}
      {!isLoading && assetList?.length > 0 && (
        <>
          <SortableTable
            columns={columns}
            data={assetList}
            currentPage={currentPage}
            limit={limit}
            className="resume custom"
          />
          <div className="row">
            <div className="col-md-3">
              <div>
                {/* Dropdown for selecting items per page */}
                <label htmlFor="itemsPerPage">Items per page </label>
                <select
                  id="itemsPerPage"
                  onChange={handleLimitChange}
                  value={limit}
                  className="border ms-3 w-25 p-2"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={40}>40</option>
                </select>
              </div>
            </div>
            <div className="col-md-9">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default EmployeeAsset;
